module.exports = __webpack_public_path__ + "static/ssr-da635c7c4c83cc1b07d996607f3170a6.png";